const { colorCodes } = require("./ral")

const commitTime = 1743584851
const release = "renz-eshop.r1075-heads-early-0-g44840d5"

const apiClientBaseURL = "/api/"

// @ts-ignore
if (typeof context !== "undefined" && !context.job) {
    context.response.header("x-commit-time", commitTime)
    context.response.header("x-release", release)
}

module.exports = {
    release,
    commitTime,

    apiClientBaseURL,

    frontendBase:"https://early.renzshop.testversion.online/",
    tibiUrl:"https://renz.tibicms.de/",

    paypalMode:"sandbox",
    paypalSandboxClientId: "ATB573Se5rXuAjycTXzM4owKNryQgitmLC9slLEVa4Bq6OFL9vjcs5kDxH-d2HODu-UB0pLJBmpGD1xo",
    paypalLiveClientId: "AU0DZtHMPhI0YW_TyYnGsJ36R4fXaWZcyCkrWVQ1AbbXmbu8fYW5cZkb2I5XMjSXvlAAFhEn6QRiSt1k",

    klarnaMode: "sandbox", // sandbox is klarna playground, live is production

    pricingRules: [
        { from: 500, discount: 0 },
        { from: 1000, discount: 15 },
        { from: 2000, discount: 20 },
        { from: 5000, discount: 27.5 },
        { from: 10000, discount: 31.5 },
        { from: 20000, discount: 33.5 },
    ],

    colorCodes,
    colorGroup1: colorCodes.filter((c) => {
        if (c.RAL == "9007" || c.RAL == "9016") {
            return true
        }
    }),

    minimumQuantrySurchargeThreshold: 30,

    currency: {
        code: "EUR",
        sign: "€",
        position: "left",
    },

    defaultVAT: 19,

    paymentMethods: ["paypal", "klarna", "invoice"],

    sameBillingAndDeliveryAddress: false,

    cryptchaSiteId: "6384e08e672a300001a21762",

    einfoApiUrl:"https://dev.einfo.renz24.de/api/",

    maxInputLength: {
        firstname: 30,
        lastname: 30,
        company: 30,
        street: 28,
        houseNumber: 30,
        postcode: 10,
        city: 30,
        email: 56,
        phone: 15,
        commission: 30,
        constructionProject: 30,
    },

    shippingCostsByFactor: [
        // greater 0 and less than 1
        { from: 0, cost: 12.9 },
        // greater 1
        { from: 1, cost: 69.9 },
    ],
}
